(() => {
  'use strict';

  if (window.__abArticleCtaTrackingV1) return;
  window.__abArticleCtaTrackingV1 = true;

  const articles = {
    "R1": {
      "path": "/blogs/news/母子手帳ケースおすすめ-大容量-おしゃれ-出産祝い-選び方",
      "products": {
        "top": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ],
        "middle": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ],
        "bottom": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ]
      }
    },
    "R2": {
      "path": "/blogs/news/news-149",
      "products": {
        "top": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ],
        "middle": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ],
        "bottom": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ]
      }
    },
    "R3": {
      "path": "/blogs/news/news-139",
      "products": {
        "top": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ],
        "middle": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ],
        "bottom": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ]
      }
    },
    "R4": {
      "path": "/blogs/news/article-1768954524080-3b3vze",
      "products": {
        "top": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ],
        "middle": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ],
        "bottom": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ]
      }
    },
    "R5": {
      "path": "/blogs/news/出産祝いにはおしゃぶりがおすすめ-おしゃぶりの種類や選び方を解説",
      "products": {
        "top": [
          "gid://shopify/Product/7066682917022",
          "/products/名入れ-ネームカスタマイズおしゃぶり-マットカラー"
        ],
        "middle": [
          "gid://shopify/Product/5523034407070",
          "/products/おしゃぶり-ケースset"
        ],
        "bottom": [
          "gid://shopify/Product/7066682917022",
          "/products/名入れ-ネームカスタマイズおしゃぶり-マットカラー"
        ]
      }
    },
    "R6": {
      "path": "/blogs/news/出産祝いにおすすめのブランドは何-代表的な人気ブランド一挙公開",
      "products": {
        "top": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ],
        "middle": [
          "gid://shopify/Product/7272751366302",
          "/products/set"
        ],
        "bottom": [
          "gid://shopify/Product/8871358824606",
          "/products/出産祝い-ママと赤ちゃんの通院-離乳食セット-母子手帳ケース-名入れ食器4点"
        ]
      }
    },
    "N1": {
      "path": "/blogs/news/personalized-baby-tableware-gift-guide",
      "products": {
        "top": [
          "gid://shopify/Product/7272751366302",
          "/products/set"
        ],
        "middle": [
          "gid://shopify/Product/7272751366302",
          "/products/set"
        ],
        "bottom": [
          "gid://shopify/Product/7272751366302",
          "/products/set"
        ]
      }
    },
    "N2": {
      "path": "/blogs/news/mirror-birth-announcement-guide",
      "products": {
        "top": [
          "gid://shopify/Product/7965875241118",
          "/products/mirror"
        ],
        "middle": [
          "gid://shopify/Product/7965875241118",
          "/products/mirror"
        ],
        "bottom": [
          "gid://shopify/Product/7965875241118",
          "/products/mirror"
        ]
      }
    },
    "N3": {
      "path": "/blogs/news/personalized-bib-baby-gift-guide",
      "products": {
        "top": [
          "gid://shopify/Product/5523096109214",
          "/products/ネームカスタマイズ-よだれかけ"
        ],
        "middle": [
          "gid://shopify/Product/5523096109214",
          "/products/ネームカスタマイズ-よだれかけ"
        ],
        "bottom": [
          "gid://shopify/Product/5523096109214",
          "/products/ネームカスタマイズ-よだれかけ"
        ]
      }
    },
    "N4": {
      "path": "/blogs/news/mom-baby-gift-set-guide",
      "products": {
        "top": [
          "gid://shopify/Product/8871358824606",
          "/products/出産祝い-ママと赤ちゃんの通院-離乳食セット-母子手帳ケース-名入れ食器4点"
        ],
        "middle": [
          "gid://shopify/Product/8871358824606",
          "/products/出産祝い-ママと赤ちゃんの通院-離乳食セット-母子手帳ケース-名入れ食器4点"
        ],
        "bottom": [
          "gid://shopify/Product/8871358824606",
          "/products/出産祝い-ママと赤ちゃんの通院-離乳食セット-母子手帳ケース-名入れ食器4点"
        ]
      }
    },
    "B1": {
      "path": "/blogs/news/出産祝いにおすすめのギフトは何-出産祝いの相場も解説",
      "products": {
        "top": [
          "gid://shopify/Product/5523096109214",
          "/products/ネームカスタマイズ-よだれかけ"
        ],
        "middle": [
          "gid://shopify/Product/7066682917022",
          "/products/名入れ-ネームカスタマイズおしゃぶり-マットカラー"
        ],
        "bottom": [
          "gid://shopify/Product/5523034407070",
          "/products/おしゃぶり-ケースset"
        ]
      }
    },
    "B2": {
      "path": "/blogs/news/news-65",
      "products": {
        "top": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ],
        "middle": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ],
        "bottom": [
          "gid://shopify/Product/8436814872734",
          "/products/memo"
        ]
      }
    },
    "B3": {
      "path": "/blogs/news/child-drawing-keychain-guide",
      "products": {
        "top": [
          "gid://shopify/Product/8264989311134",
          "/products/key"
        ],
        "middle": [
          "gid://shopify/Product/8264989311134",
          "/products/key"
        ],
        "bottom": [
          "gid://shopify/Product/8264989311134",
          "/products/key"
        ]
      }
    },
    "B4": {
      "path": "/blogs/news/grandparents-personalized-keepsake-guide",
      "products": {
        "top": [
          "gid://shopify/Product/7965875241118",
          "/products/mirror"
        ],
        "middle": [
          "gid://shopify/Product/8264989311134",
          "/products/key"
        ],
        "bottom": [
          "gid://shopify/Product/8645758779550",
          "/products/木-命名書"
        ]
      }
    }
  };
  const selector = 'a[data-article-key][data-cta-position][data-product-id]';
  const owns = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const pathOnly = (path) => decodeURIComponent(path).replace(/\/$/, '');

  let privacyApiLoading = false;
  const ensurePrivacyApiReady = () => {
    try {
      const shopify = window.Shopify;
      if (typeof shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function') return true;
      if (privacyApiLoading || typeof shopify?.loadFeatures !== 'function') return false;

      privacyApiLoading = true;
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
        privacyApiLoading = false;
      });
    } catch {
      privacyApiLoading = false;
    }
    return false;
  };

  ensurePrivacyApiReady();

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;

    try {
      const target = event.target?.nodeType === 1 ? event.target : event.target?.parentElement;
      const anchor = target?.closest(selector);
      if (!anchor) return;

      const articleKey = anchor.getAttribute('data-article-key');
      const position = anchor.getAttribute('data-cta-position');
      const productId = anchor.getAttribute('data-product-id');
      if (!owns(articles, articleKey)) return;
      const article = articles[articleKey];
      if (!owns(article.products, position)) return;
      if (pathOnly(window.location.pathname) !== article.path) return;

      const [expectedId, expectedPath] = article.products[position];
      const href = new URL(anchor.getAttribute('href'), window.location.href);
      if (productId !== expectedId || href.protocol !== 'https:' ||
          href.origin !== window.location.origin || href.username || href.password ||
          !href.pathname.startsWith('/products/') || pathOnly(href.pathname) !== expectedPath) return;

      if (!ensurePrivacyApiReady()) return;
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function' ||
          privacy.analyticsProcessingAllowed() !== true || typeof window.gtag !== 'function') return;

      window.gtag('event', 'article_cta_click', {
        send_to: 'G-L11TZ4WJQJ',
        article_key: articleKey,
        cta_position: position,
        product_id: productId,
        article_path: article.path
      });
    } catch {}
  }, { passive: true });
})();
